<template>
  <div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-1">
        </div>
        <div class="col-2">
          <h6>Room</h6>
        </div>
        <div class="col-2">
          <h6>Appliance</h6>
        </div>
        <div class="col-2">
          <h6>Brand</h6>
        </div>
        <div class="col-2">
          <h6>Model</h6>
        </div>
        <div class="col-1">
          <h6>Year</h6>
        </div>
        <div class="col-1">
        </div>
        <div class="col-1">
        </div>
      </div>
      <div class="row" v-for="(appliance, index) in appliances.slice(0,5)" v-bind:key="index" v-on:click="editAppliance(appliance, index)">
        <div class="col-1">
          <i v-if="showDelete" class="fa fa-trash" v-on:click.stop="deleteAppliance(index)"></i>
        </div>
        <div class="col-2">
          <p>{{ appliance.room }}</p>
        </div>
        <div class="col-2">
          <p>{{ appliance.appliance }}</p>
        </div>
        <div class="col-2">
          <p>{{ appliance.brand }}</p>
        </div>
        <div class="col-2">
          <p>{{ appliance.model_number }}</p>
        </div>
        <div class="col-1">
          <p>{{ extractYear(appliance.purchase_date) }}</p>
        </div>
        <div class="col-1">
          <i v-if="appliance.note" class="fa fa-sticky-note"></i><!-- TODO: v-on:click="pullUpModalToDisplay" -->
        </div>
        <div class="col-1">
          <i v-if="appliance.attachments" class="fa fa-paperclip"></i><!-- TODO: v-on:click="pullUpModalToDisplay" -->
        </div>
      </div>
      <div v-if="appliances.length" class="row button-padding">
        <div class="col-4 offset-2">
          <button class="btn btn-primary" v-on:click="showApplianceModal">Add Appliance</button>
        </div>
        <div class="col-4">
          <button class="btn btn-secondary" v-on:click="showDelete = !showDelete">Delete Appliance</button>
        </div>
      </div>
      <div v-else class="row button-padding">
        <div class="col-4 offset-4">
          <button class="btn btn-primary" v-on:click="showApplianceModal">Add Appliance</button>
        </div>
      </div>
      <appliance-modal ref="applianceModal" v-bind:propertyId="propertyId" v-bind:editAppliance="applianceToEdit" v-bind:editIndex="editIndex" v-bind:rooms="rooms" v-bind:applianceOptions="applianceOptions" v-on:resetEditApplianceValues="resetEditApplianceValues()"></appliance-modal>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import ApplianceModal from './ApplianceModal.vue'

export default {
  data () {
    return {
      applianceToEdit: null,
      editIndex: -1,
      showDelete: false
    }
  },
  components: {
    ApplianceModal
  },
  props: {
    applianceOptions: Array,
    appliances: {
      type: Array,
      default () {
        return []
      }
    },
    propertyId: String,
    rooms: Array
  },
  methods: {
    ...mapMutations('property', [
      'removeIndexFromDetailedAppliances'
    ]),
    ...mapActions('property', [
      'putPropertyData'
    ]),
    async deleteAppliance (index) {
      this.loading = true
      try {
        this.removeIndexFromDetailedAppliances(index)
        await this.putPropertyData({ uniqueId: this.propertyId })
      } catch (error) {
        console.log(error)
      }
      this.loading = false
    },
    editAppliance (appliance, index) {
      this.applianceToEdit = appliance
      this.editIndex = index
      this.$refs.applianceModal.$refs.applianceModal.show()
    },
    extractYear (timestamp) {
      if (!timestamp) return timestamp
      let dateComponents = timestamp.split(/\D/)
      return dateComponents[0]
    },
    resetEditApplianceValues () {
      this.editIndex = -1
      this.applianceToEdit = null
    },
    showApplianceModal () {
      this.$refs.applianceModal.$refs.applianceModal.show()
    }
  }
}
</script>

<style scoped>
.btn-secondary {
  width: 100%;
}

.button-padding {
  margin-top: 0.3rem;
  margin-bottom: 0.3rem;
}

.fa-trash {
  cursor: pointer;
}

.fa-paperclip {
  transform: rotate(-45deg);
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeData/dropdowns/Appliances.vue